import { createAction, props } from '@ngrx/store';
import { ListTeamUserTransfersOutput } from '@smash-sdk/transfer/01-2024';

export const loadTransfersSent = createAction(
  '[TransfersSent] Load Transfers Sent',
);

export const loadTransfersSentSuccess = createAction(
  '[TransfersSent] Load Transfers Sent Success',
  props<{ transfers: (ListTeamUserTransfersOutput['transfers'][0] & { team: string, receiversNumber: number, sender: string, receiverEmails: string, type: string })[] }>()
);

export const loadTransfersSentFailure = createAction(
  '[TransfersSent] Load Transfers Sent Failure',
  props<{ error: string }>()
);

export const loadTransfer = createAction(
  '[TransfersSent] Load Transfer',
  props<{ transferId: string }>()
);

export const deleteTransfer = createAction(
  '[TransfersSent] Delete Transfer',
  props<{ transferId: string }>()
);

export const deleteTransferSuccess = createAction(
  '[TransfersSent] Delete Transfer Success',
  props<{ transferId: string }>()
);

export const deleteTransferFailure = createAction(
  '[TransfersSent] Delete Transfer Failure',
  props<{ error: string }>()
);




